const translations = {
    noteGrounded: 'Grounded — unavailable for flight',
    noteHold: 'On hold — awaiting review'
};

export default translations;
